import { useCareerStore } from "@/stores/career";
export function searchbarInput(id){
    useCareerStore().searchbarInput(document.getElementById(id).value);
}
